import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import cloudStore from "../../store/CloudStore";
import { Checkbox, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { _delete, _post } from "../../Api";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import GetAppIcon from "@material-ui/icons/GetApp";
import QRCode from "qrcode.react";
import withIntl from "../../utils/withIntl";
import EditTextField from "../EditArticle/EditTextField";
import { updateQrCodes } from "./WebcodeApi";
import EditSelect from "../EditArticle/EditSelect";
import EditSwitch from "../EditArticle/EditSwitch";
import EditIcon from "@material-ui/icons/Edit";
import DoneIcon from "@material-ui/icons/Done";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";
import AuthorizationWrapper from "../AuthorizationWrapper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    // backgroundColor: "pink",
    flexFlow: "row wrap",
  },
  root1: {
    flexGrow: 1,
    position: "relative",
    padding: theme.spacing(1),
    flexFlow: "row wrap",
    // border: "solid 2px purple",
  },
  section: {
    margin: 1,
    // border: "solid 2px orange",
  },
  subSection: {
    margin: 1,
    // border: "solid 2px pink",
  },
  paper: {
    width: "45%",
    margin: 10,
    // padding: theme.spacing(2),
    // textAlign: "center",
    color: theme.palette.text.secondary,
    // height: 50,
  },
  switchContainer: {
    flexFlow: "row wrap",
    height: "auto",
    paddingLeft: 10,
    // border: "solid green 2px",
  },
  inputsContainer: {
    flexFlow: "row wrap",
    height: "auto",
    paddingTop: 20,
  },
  label: {
    fontSize: 12,
  },
}));

function WebcodeSetting(props) {
  const classes = useStyles();
  const { index, merchantType } = props;
  const [webcode, setWebcode] = useState(props.webcode);
  const history = useHistory();
  const [hasPaymentError, setPaymentError] = React.useState(false);
  const [editModeIdentifier, setEditModeIdentifier] = React.useState(false);
  const [allSettingTypes, setSettingTypes] = useState({
    ask_contact_details: {
      omschrijving: props.intl.formatMessage({ id: "ask_for_contact_details" }),
      hide: true,
      merchant: ["spMerchant"],
      type: "switch",
    },
    enable_remark_in_ordergroup: {
      omschrijving: props.intl.formatMessage({ id: "allow_remarks" }),
      hide: true,
      merchant: ["spMerchant"],
      type: "switch",
    },
    is_ordering: {
      omschrijving: props.intl.formatMessage({ id: "allow_ordering" }),
      hide: false,
      merchant: ["spMerchant"],
      type: "switch",
    },
    sp_shielded_receipt: {
      omschrijving: props.intl.formatMessage({ id: "individual_bills" }),
      hide: true,
      merchant: ["spMerchant"],
      type: "switch",
    },
    sp_share_order: {
      omschrijving: props.intl.formatMessage({ id: "synchronized_ordering" }),
      hide: true,
      merchant: ["spMerchant"],
      type: "switch",
    },
    sp_is_every_order_paid: {
      omschrijving: props.intl.formatMessage({ id: "pay_directly" }),
      hide: false,
      merchant: ["spMerchant"],
      type: "switch",
    },
    sp_auto_close_receipts: {
      omschrijving: "sp_auto_close_receipts",
      hide: true,
      merchant: ["spMerchant", "taMerchant"],
      type: "switch",
    },
    do_ta_postal_code_check: {
      omschrijving: "Postcodes controleren",
      hide: false,
      merchant: ["taMerchant"],
      type: "switch",
    },
    label: {
      omschrijving: props.intl.formatMessage({ id: "label" }),
      hide: false,
      merchant: ["spMerchant", "taMerchant"],
      type: "select",
      optionValues: ["mynober", "ibutler", "alfredqr"],
      optionViewValues: ["MynOber", "iButler", "AlfredQR"],
    },
    menu_tag: {
      omschrijving: props.intl.formatMessage({ id: "menu_tag" }),
      hide: false,
      merchant: ["spMerchant", "taMerchant"],
      type: "string",
    },
    print_tag: {
      omschrijving: props.intl.formatMessage({ id: "print_tag" }),
      hide: false,
      merchant: ["spMerchant", "taMerchant"],
      type: "string",
    },
    redirect_url: {
      omschrijving: props.intl.formatMessage({ id: "Redirect url" }),
      hide: false,
      merchant: ["spMerchant", "taMerchant"],
      type: "string",
      nullable: true,
    },
  });
  let QRCodeLink = `https://web.mynober.com/qr/${webcode.identifier}`;
  if (webcode.label === "ibutler") {
    QRCodeLink = `https://web.ibutler.online/qr/${webcode.identifier}`;
  } else if (webcode.label === "alfredqr") {
    QRCodeLink = `https://web.alfredqr.com/qr/${webcode.identifier}`;
  }

  //// Add key
  Object.keys(allSettingTypes).forEach((settingKey) => {
    allSettingTypes[settingKey]["key"] = settingKey;
  });
  //settingsArray: hide false, setting exists in cloudStore, setting added in settingTypes (above)
  let selectedSettingTypeKeys = webcode && Object.keys(webcode); // all settingkeys from CloudStore
  selectedSettingTypeKeys = selectedSettingTypeKeys.filter((settingKey) =>
    allSettingTypes[settingKey]?.merchant.includes(merchantType)
  );
  selectedSettingTypeKeys = selectedSettingTypeKeys.filter(
    (settingKey) => allSettingTypes[settingKey] && !allSettingTypes[settingKey].hide
  );

  const updateSetting = (setting) => {
    const body = [{ identifier: webcode.identifier, [setting.key]: webcode[setting.key] }];
    _post(`/nova/v2/merchant/${cloudStore.merchant.id}/sp_qr_codes`, body)
      .then((res) => {
        setWebcode(res.data[0]);
      })
      .catch((e) => {
        console.log(e);
        toast.error(props.intl.formatMessage({ id: "something_went_wrong" }), {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const deleteWebcodeSetting = () => {
    const data = [{ identifier: webcode.identifier }];
    _delete(`/nova/v2/merchant/${cloudStore.merchant.id}/sp_qr_codes`, data)
      .then((res) => {
        history.go(0);
        toast.success(props.intl.formatMessage({ id: "deleted_successfully" }), {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((e) => {
        console.log(e);
        toast.error(props.intl.formatMessage({ id: "something_went_wrong" }), {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleChangePaymentSettings = (event, method) => {
    const inputValue = event.target.value;
    const paymentProperty = event.target.name;
    let paymentType = Object.keys(method)[0];
    method[paymentType][paymentProperty] = parseFloat(inputValue);
    let newSettingTypes = { ...allSettingTypes };
    let newPaymentSettings = newSettingTypes.sp_payment_methods;
    let index = newPaymentSettings.value.findIndex((paymentMethod) => paymentMethod[Object.keys(method)[0]]);
    let newValue = newPaymentSettings.value;
    newValue[index] = method;
    setSettingTypes(newSettingTypes);
  };

  const updateQrCode = (settingKey, value) => {
    updateQrCodes(cloudStore.merchant.id, [webcode], [{ [settingKey]: value }]).then((spQrCodes) => {
      Object.keys(webcode).forEach((key) => {
        webcode[key] = spQrCodes[0][key];
      });
      setWebcode(spQrCodes[0]);
    });
  };

  const downloadQRCode = () => {
    const canvas = document.getElementById("qrcode");
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = ` ${QRCodeLink}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Paper className={classes.paper}>
      <Grid container spacing={1} className={classes.root1} xs={12} md={12}>
        {/*<IconButton aria-label="delete" style={{ position: "absolute", top: 5, right: 5 }}>*/}
        {/*  <DeleteIcon onClick={deleteWebcodeSetting} />*/}
        {/*</IconButton>*/}
        <Grid container item className={classes.section} spacing={1} xs={12} md={12}>
          <div style={{ display: "flex", alignItems: "baseline", width: "100%" }}>
            <Typography align="center" variant={"h6"} style={{ width: "10%" }}>
              {index + 1}.
            </Typography>
            {editModeIdentifier ? (
              <div style={{ dislay: "inline", width: "30%" }}>
                <EditTextField
                  key={webcode.identifier + "-" + webcode.updated_at}
                  authorizationField={"qr_codes.name"}
                  value={webcode.identifier == null ? "" : webcode.identifier}
                  onBlur={(value) => {
                    value = value === "" ? null : value;
                    updateQrCode("webcode", value);
                  }}
                  placeholder={"name"}
                />
              </div>
            ) : (
              <Typography align="center" variant={"h6"} style={{ width: "30%" }}>
                {webcode.identifier}
              </Typography>
            )}
            {editModeIdentifier ? (
              <div style={{ dislay: "inline", width: "30%", marginLeft: 5 }}>
                <EditTextField
                  key={webcode.table_id + "-" + webcode.updated_at}
                  authorizationField={"qr_codes.name"}
                  value={webcode.table_id == null ? "" : webcode.table_id}
                  onBlur={(value) => {
                    value = value === "" ? null : value;
                    updateQrCode("table_id", value);
                  }}
                  placeholder={"table_id"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{props.intl.formatMessage({ id: "table" })} -</InputAdornment>
                    ),
                  }}
                />
              </div>
            ) : (
              <Typography align="center" variant={"h6"} style={{ width: "30%" }}>
                : {props.intl.formatMessage({ id: "table" })} - {webcode.table_id}
              </Typography>
            )}
            <AuthorizationWrapper
              permission={"qr_codes.name"}
              child={(write) => {
                return (
                  <IconButton disabled={!write} onClick={() => setEditModeIdentifier((prevState) => !prevState)}>
                    {editModeIdentifier ? <DoneIcon /> : <EditIcon />}
                  </IconButton>
                );
              }}
            />
            <AuthorizationWrapper
              permission={"qr_codes.move"}
              child={(write) => {
                return (
                  <Checkbox
                    disabled={!write}
                    checked={Boolean(props.selectedQrCodeIdentifiers[webcode.identifier])}
                    onChange={(e) => {
                      props.setSelectedSpQrCodeIdentifier(webcode.identifier, e.target.checked);
                    }}
                  />
                );
              }}
            />
          </div>
        </Grid>
        <Divider style={{ marginTop: "8px", marginBottom: "8px", width: "100%" }} />
        <Grid container className={classes.section} spacing={1} xs={12} md={6}>
          <Grid container item spacing={1} className={classes.inputsContainer}>
            {selectedSettingTypeKeys.map((settingKey) => {
              let setting = allSettingTypes[settingKey];
              switch (setting.type) {
                case "string":
                  return (
                    <EditTextField
                      key={setting.key + "-" + webcode.updated_at}
                      authorizationField={"qr_codes." + setting.key}
                      value={webcode[setting.key] == null ? "" : webcode[setting.key]}
                      label={setting.omschrijving}
                      onBlur={(value) => {
                        value = value === "" ? null : value;
                        updateQrCode(setting.key, value);
                      }}
                    />
                  );
                case "select":
                  return (
                    <EditSelect
                      key={setting.key + "-" + webcode.updated_at}
                      authorizationField={"qr_codes." + setting.key}
                      value={webcode[setting.key] == null ? "mynober" : webcode[setting.key]}
                      optionValues={setting.optionValues}
                      optionViewValues={setting.optionViewValues}
                      label={setting.omschrijving}
                      onChange={(value) => {
                        updateQrCode(setting.key, value);
                      }}
                    />
                  );
                default:
                  return null;
              }
            })}
          </Grid>
        </Grid>
        <Grid container className={classes.section} xs={12} md={5}>
          <Grid item>
            <IconButton onClick={() => window.open(QRCodeLink)}>
              QR
              {/*<QRCode bgColor="#FFFFFF" value={QRCodeLink} size="120" id="qrcode" />*/}
            </IconButton>
            <AuthorizationWrapper
              permission={"sp_qr_codes.downloads"}
              child={
                <IconButton onClick={downloadQRCode} aria-label="delete">
                  <GetAppIcon />
                  <Typography variant="caption">QRCode</Typography>
                </IconButton>
              }
            />
          </Grid>
        </Grid>
        <Grid container className={classes.section} spacing={1}>
          <Grid container spacing={1} className={classes.switchContainer}>
            {selectedSettingTypeKeys.map(
              (settingKey) =>
                allSettingTypes[settingKey].type === "switch" && (
                  <EditSwitch
                    key={settingKey + "-" + webcode.updated_at}
                    value={webcode[settingKey]}
                    authorizationField={"qr_codes." + settingKey}
                    label={allSettingTypes[settingKey].omschrijving}
                    onChange={(value) => {
                      updateQrCode(settingKey, value);
                    }}
                  />
                )
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default withIntl(WebcodeSetting);
